import {AutocompleteItem} from "@heroui/react";
import {useAsyncList} from "@react-stately/data";
import {apiCall} from "../api.ts";
import {VedicrishiPlace} from "../types";

import PAutocomplete from "./PAutocomplete.tsx";

const PAutocompleteCity = (params: { countryCode: string, label: string } | any) => {
    const list = useAsyncList({
        async load({signal, filterText}) {
            const res = await apiCall('geo-search', {countryCode: params.countryCode, searchText: filterText}, {signal});
            const json = await res.json();
            return {
                items: json,
            };
        },
    });

    return <PAutocomplete
        labelPlacement="outside"
        isLoading={list.isLoading}
        items={list.items}
        placeholder={params.selectedKey || params.defaultSelectedKey || "Start typing..."}
        onInputChange={list.setFilterText}
        listboxProps={{
            emptyContent: "Enter at least 3 letters",
        }}
        {...params}
        onSelectionChange={(sel) => {
            // return complete object instead of just a key
            params.onSelectionChange(list.items.find((item: any) => item.place === sel))
        }}
    >
        {(item: VedicrishiPlace) =>
            PAutocompleteCityItem({item})
        }
    </PAutocomplete>
}

export function PAutocompleteCityItem({item}: { item: VedicrishiPlace }): any {
    return <AutocompleteItem key={item.place} textValue={item.place}>
        <div className="flex justify-between players-center">
            <div className="flex gap-2 players-center">
                <div className="flex flex-col">
                    <span className="text-small">{item.place}</span>
                    <span className="text-tiny text-default-400">{item.country}</span>
                </div>
            </div>
        </div>
    </AutocompleteItem>
}

export default PAutocompleteCity;
